import { Controller } from '@hotwired/stimulus'
import Logger from '../lib/logger'

export default class extends Controller {
  static targets = ['filterChip', 'filterRemove', 'searchForm']

  connect() {
    Logger.debug('MobileStickyFilterController connected')
  }

  disconnect() {
    Logger.debug('MobileStickyFilterController disconnected')
  }

  removeFilter(event) {
    event.preventDefault()

    const filterName = event.currentTarget.dataset.filterName
    const filterValue = event.currentTarget.dataset.filterValue

    // Remove the filter value from params
    const url = new URL(window.location.href)
    
    // Handle different filter types
    if (filterName === 'id_eq') {
      url.searchParams.delete('q[id_eq]')
    } else if (filterName === 'customer_name_cont') {
      url.searchParams.delete('q[customer_name_cont]')
    } else if (filterName === 'customer_ref_cont') {
      url.searchParams.delete('q[customer_ref_cont]')
    } else if (filterName === 'end_users_name_cont') {
      url.searchParams.delete('q[end_users_name_cont]')
    } else if (filterName === 'pending') {
      url.searchParams.delete('pending')
    } else if (filterName === 'has_priority') {
      url.searchParams.delete('has_priority')
    }

    // Navigate to the new URL
    window.location.href = url.toString()
  }
}